import styled from "styled-components";
import {grayColors} from "../../../../../../themes/architecture/gray-colors";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";

export const AppliedFilterIndicatorBox = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 2px solid ${hexToRgba(grayColors.gray183 ,0.3)};
    border-radius: 4px;
    padding: 0 12px;
    line-height: 3rem;
    margin-left: 2px;
`